<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      @onGroupDelete="groupDelete"
    >
      <template #leftHeader="{ selectList }">
        <b-button
          v-if="selectList.length"
          variant="outline-danger"
          :disabled="isSubmit"
          @click="groupDelete"
        >
          {{ $t("general.groupDelete") }} {{ selectList.length ? `(${selectList.length})` : "" }}
        </b-button>
        <b-button
          v-if="selectList.length"
          variant="outline-info"
          :disabled="isSubmit"
          @click="() => groupArchive(selectList)"
        >
          {{ $t("suggestions.archive") }} {{ $t("general.group") }} {{ selectList.length ? `(${selectList.length})` : "" }}
        </b-button>
        <b-button
          variant="outline-primary"
          :disabled="isSubmit"
          @click="exportExcelAndDownload"
        >
          {{ $t("general.exportExcel") }}
        </b-button>
      </template>
      <!-- Column: Archive -->
      <template #cell(archive)="{ item }">
        <b-form-checkbox
          :checked="item.archive"
          class="mt-1"
          switch
          inline
          @change="(val) => toggleArchive(item._id, val)"
        />
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row @click.native="toEditPage(item._id)" />
        <delete-row @click.native="deleteItem(item._id)" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import {
  BButton,
  BFormCheckbox,
} from 'bootstrap-vue'
import BDataTable from '@/components/BDataTable/index.vue'
import DeleteRow from '@/components/BDataTable/Actions/DeleteRow.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import useSuggestionsList from './useSuggestionsList'

export default {
  name: 'SuggestionList',
  components: {
    BButton,
    BDataTable,
    BFormCheckbox,
    DeleteRow,
    EditRow,
    LayoutLoading,
  },
  setup() {
    const {
      deleteItem,
      exportExcel,
      fetchList,
      groupArchive,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
      toggleArchive,
      exportExcelUrl,
    } = useSuggestionsList()
    return {
      deleteItem,
      exportExcel,
      fetchList,
      groupArchive,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
      toggleArchive,
      exportExcelUrl,
    }
  },
  methods: {
    exportExcelAndDownload() {
      this.exportExcel().then(response => {
        const url = URL.createObjectURL(new Blob([response.data], {
          type: 'application/vnd.ms-excel',
        }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'suggestion')
        document.body.appendChild(link)
        link.click()
      })
    },
  },
}
</script>
